import { WithdrawTransactionApi } from '../../generated/api';
import configuration from './configuration';

export default new WithdrawTransactionApi(configuration);
